import React, { useMemo, useState, useEffect } from 'react';
import { Container, Row, Col, Card, Stack, Badge, InputGroup, Form, Alert } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLocationDot, faMagnifyingGlass, faGear, faHeart } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import { DataManager } from '../../core/data-manager';
import { LoginManager } from '../../core/login-manager';
import { LanguageProvider } from '../../core/language-provider';
import moment from 'moment/moment';
import { useNavigate } from 'react-router-dom';

export default function Profile() {
    const blue = '#0A2B5E';
    const lightBlue = '#2FAAE0';
    const userInfo = LoginManager.getUserInfo();

    // Mock data for UI (replace with API later)
    const [qApplied, setQApplied] = useState('');
    const [applied, setApplied] = useState(null);
    const [qFav, setQFav] = useState('');
    const [favorites, setFavorites] = useState(null);
    const navigate = useNavigate();


    async function getJobRequest() {
        var sorting = {
            'field': 'id',
            'order': 'desc'
        }
        var constraints = [
            {
                "fieldName": "idUser",
                "type": "value",
                "value": userInfo.id
            }
        ]
        var r = await DataManager.searchItems('job_request', 1, 50, sorting, qApplied, [], constraints);
        if (r.success === 1) {
            console.log(r.body)
            setApplied(r.body)
        }
    }


    async function getJobFavorite() {
        var sorting = {
            'field': 'id',
            'order': 'desc'
        }
        var constraints = [
            {
                "fieldName": "idUser",
                "type": "value",
                "value": userInfo.id
            }
        ]
        var r = await DataManager.searchItems('job_post_favourites', 1, 50, sorting, qFav, [], constraints);
        if (r.success === 1) {
            console.log(r.body)
            setFavorites(r.body)
        }
    }

    useEffect(() => {
        getJobRequest()
        getJobFavorite()
    }, [userInfo]);


    // Filter displayed cards by title based on search bars
    const appliedFiltered = useMemo(() => {
        if (!applied) return null;
        const q = (qApplied || '').trim().toLowerCase();
        if (!q) return applied;
        return applied.filter(item => (item?.idJobPost?.title || '').toLowerCase().includes(q));
    }, [applied, qApplied]);

    const favoritesFiltered = useMemo(() => {
        if (!favorites) return null;
        const q = (qFav || '').trim().toLowerCase();
        if (!q) return favorites;
        return favorites.filter(item => (item?.idJobPost?.title || '').toLowerCase().includes(q));
    }, [favorites, qFav]);



    return (
        <Container fluid>
            <Container fluid={'md'}>
                {/* Header */}
                <Row className='pt-5 pb-3 align-items-center mb-4'>
                    <Col>
                        <div className='text-muted'>{LanguageProvider.get('pages.profile.greeting')}</div>
                        <h1 style={{ color: blue }}>{userInfo && userInfo.name} {userInfo && userInfo.surname}</h1>
                    </Col>
                    <Col xs='auto'>
                        <Link to='/profile/settings' aria-label={LanguageProvider.get('pages.profile.settingsAria')} style={{ color: blue }}>
                            <FontAwesomeIcon icon={faGear} />
                        </Link>
                    </Col>
                </Row>

                {/* Applied */}
                <Row className='align-items-center mb-3'>
                    <Col md={6} xs={12} className='text-md-start text-center'>
                        <div className='fw-semibold' style={{ color: '#6c757d' }}>{LanguageProvider.get('pages.profile.applied')}</div>
                    </Col>
                    <Col md={6} xs={12} className='mt-2 mt-md-0'>
                        <InputGroup>
                            <InputGroup.Text style={{ background: 'transparent', borderRight: 'none' }}>
                                <FontAwesomeIcon icon={faMagnifyingGlass} />
                            </InputGroup.Text>
                            <Form.Control
                                style={{ borderLeft: 'none' }}
                                placeholder={LanguageProvider.get('pages.profile.searchPlaceholder')}
                                value={qApplied}
                                onChange={(e) => setQApplied(e.target.value)}
                            />
                        </InputGroup>
                    </Col>
                </Row>

                {appliedFiltered && appliedFiltered.length > 0 ? <>
                    <Stack gap={3} className='mb-5'>
                        {appliedFiltered.map((job) => (
                            <Card key={job.id} style={{ borderColor: '#e6edf5', cursor: 'pointer' }} onClick={() => navigate(`/job/${job.idJobPost.id}`)}>
                                <Card.Body>
                                    <Row className='align-items-start'>
                                        <Col>
                                            <Card.Title style={{ color: blue, fontWeight: 600 }}>{job.idJobPost.title}</Card.Title>
                                            <div className='mb-2' style={{ color: lightBlue, textTransform: 'uppercase', fontSize: 12 }}>
                                                <FontAwesomeIcon icon={faLocationDot} /> {job.idJobPost.idLocation.country}, {job.idJobPost.idLocation.city}
                                            </div>
                                            <Card.Text className='text-muted'>
                                                <div className='richtext-clamp-3' dangerouslySetInnerHTML={{ __html: job.idJobPost.description }}></div>
                                            </Card.Text>
                                            <Stack direction='horizontal' gap={2} className='flex-wrap'>
                                                {job.idJobPost.tags && job.idJobPost.tags.map((t, i) => (
                                                    <Badge key={i} bg='' style={{ border: '1px solid #dbe7f2', color: blue, backgroundColor: '#f2f7fb', fontWeight: 500 }}>
                                                        {t.name}
                                                    </Badge>
                                                ))}
                                            </Stack>
                                        </Col>
                                        <Col xs='auto' className='text-muted' style={{ fontSize: 14 }}>
                                            inviata il: <strong>{moment(job.date).format('DD-MM-YYYY hh:mm')}</strong>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        ))}
                    </Stack>
                </> : <>
                    <Alert variant='warning' className='mb-5'>
                        {LanguageProvider.get('pages.profile.noApplied')}
                        {' '}
                        <Link to='/' style={{ color: lightBlue, textDecoration: 'none' }}>
                            {LanguageProvider.get('pages.profile.exploreLink')}
                        </Link>
                    </Alert>
                </>}

                <hr className='my-5' />

                {/* Favorites */}
                <Row className='align-items-center mb-3 mt-5'>
                    <Col md={6} xs={12} className='text-md-start text-center'>
                        <div className='fw-semibold' style={{ color: '#6c757d' }}>{LanguageProvider.get('pages.profile.favourites')}</div>
                    </Col>
                    <Col md={6} xs={12} className='mt-2 mt-md-0'>
                        <InputGroup>
                            <InputGroup.Text style={{ background: 'transparent', borderRight: 'none' }}>
                                <FontAwesomeIcon icon={faMagnifyingGlass} />
                            </InputGroup.Text>
                            <Form.Control
                                style={{ borderLeft: 'none' }}
                                placeholder={LanguageProvider.get('pages.profile.searchPlaceholder')}
                                value={qFav}
                                onChange={(e) => setQFav(e.target.value)}
                            />
                        </InputGroup>
                    </Col>
                </Row>

                {favoritesFiltered && favoritesFiltered.length > 0 ? <>
                    <Row className='g-4 mb-5'>
                        {favoritesFiltered.map((job) => (
                            <Col key={job.id} lg={4} md={6} sm={12}>
                                <Card className='h-100' style={{ borderColor: '#e6edf5', cursor: 'pointer' }} onClick={() => navigate(`/job/${job.idJobPost.id}`)}>
                                    <Card.Body>
                                        <div className='d-flex justify-content-between'>
                                            <Card.Title style={{ color: blue, fontWeight: 600 }}>{job.idJobPost.title}</Card.Title>
                                            <span
                                                role='button'
                                                aria-label='Rimuovi dai preferiti'
                                                onClick={async (e) => {
                                                    e.stopPropagation();
                                                    const del = await DataManager.deleteItem('job_post_favourites', job.id);
                                                    if (del.success === 1) {
                                                        setFavorites(prev => prev.filter(f => f.id !== job.id));
                                                    }
                                                }}
                                                style={{ color: '#E91E63', cursor: 'pointer' }}
                                            >
                                                <FontAwesomeIcon icon={faHeart} />
                                            </span>
                                        </div>
                                        <div className='mb-2' style={{ color: lightBlue, textTransform: 'uppercase', fontSize: 12 }}>
                                            <FontAwesomeIcon icon={faLocationDot} /> {job.idJobPost.idLocation.country}, {job.idJobPost.idLocation.city}
                                        </div>
                                        <Card.Text className='text-muted'>
                                            <div className='richtext-clamp-3' dangerouslySetInnerHTML={{ __html: job.idJobPost.description }}></div>
                                        </Card.Text>
                                        <Stack direction='horizontal' gap={2} className='flex-wrap'>
                                            {job.idJobPost.tags && job.idJobPost.tags.map((t, i) => (
                                                <Badge key={i} bg='' style={{ border: '1px solid #dbe7f2', color: blue, backgroundColor: '#f2f7fb', fontWeight: 500 }}>
                                                    {t.name}
                                                </Badge>
                                            ))}
                                        </Stack>
                                    </Card.Body>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                </> : <>
                    <Alert variant='warning' className='mb-5'>
                        {LanguageProvider.get('pages.profile.noFavourites')}
                        {' '}
                        <Link to='/' style={{ color: lightBlue, textDecoration: 'none' }}>
                            {LanguageProvider.get('pages.profile.exploreLink')}
                        </Link>
                    </Alert>
                </>}



            </Container>
        </Container>
    );
};
